import _ from 'underscore';
import { useEffect, useState } from 'react';

/**
 * Takes output of a hook and perform a very basic read
 * @param {Array} hook - dataState and actions returned from a data hook
 * @param {bool} bypassCache - if always read
 * @param {Object} params - params for read action
 * @param {Object} onError - function to call on error
 * @param {bool} isReadEnabled - only read if this flag is enabled
 * @return {*} pass through hook return
 */
export const useSimpleRead = (
  hook,
  bypassCache = false,
  params = {},
  onError = _.noop,
  isReadEnabled = true
) => {
  const [
    {
      isLoading,
      data,
    },
    {
      read,
    },
  ] = hook;

  const [shouldRead, setShouldRead] = useState((bypassCache || !data) && isReadEnabled);

  useEffect(() => {
    // only call read when:
    // 1. should read
    // 2. not already loading
    // 3. read is initialized
    if (shouldRead && !isLoading && read) {
      read(params).catch(e => onError(e));
      setShouldRead(false);
    }
  }, [isLoading, read, params, shouldRead, onError]);

  return hook;
};
